import NextImage from '@/components/NextImage';
import Image from '@/components/UI/Image';
import Search from '@/components/UI/Search';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/support/pc/');

export default function SupportBanner({
    searchValue,
    bgImages = '/img/support.png',
    isSearch = true,
    title,
    subTitle,
    singleTitle,
    titleShow = true,
    isNewImg = false,
    newImgList = ['support.webp', 'support.png'],
    singleShow = false,
    subTitleShow = true,
    isWebp = false,
    webpSrc,
}: any) {
    const { useRouter, useState, useEffect, useLang, gloproductlist, gtm } = useGlobal();
    const spuList =
        gloproductlist?.map((spu: any) => ({
            ...spu,
            label: spu.name,
            value: spu.spuId,
        })) || [];
    const router = useRouter();
    const { locale } = router;
    const [value, setValue] = useState('');
    const { t } = useLang('shared');

    title = title || t('support.site_support_welcome');
    singleTitle = title || t('support.site_support_welcome');
    subTitle = subTitle || t('support.site_support_picture_title');
    const dorpDownDesc = t('support.site_nav_search_recommend');

    const handleSearchGTM = (params: any) => {
        const { inputValue, selectValue, type } = params;
        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: inputValue,
            button_name: selectValue,
            type,
        });
    };
    /**
     * 处理输入框回车搜索
     * @param e
     */
    const handleEnter = (e: any) => {
        const keyword = e.target.value;
        if (e.keyCode !== 13 || !keyword) return;
        setValue(keyword); // 防止闪动
        handleSearchGTM({ inputValue: keyword, selectValue: '', type: 'Enter' });
        router.push('/support/search/[keyword]', `/${locale}/support/search/${keyword}`);
    };

    /**
     * 处理选择列表项搜索
     * @param value
     */
    const handleChange = (value: string) => {
        if (!value) return;
        setValue(value); // 防止闪动
        handleSearchGTM({
            inputValue: (document.querySelector('.supportSearchField input') as any)?.value || value,
            selectValue: value,
            type: 'Click',
        });
        router.push('/support/search/[keyword]', `/${locale}/support/search/${value || ''}`);
    };
    useEffect(() => {
        setValue(searchValue);
    }, [searchValue]);

    return (
        <div className={`${css.proBanner} supportBanner`}>
            <span className="imgLoadingBg img-wrap">
                {!isNewImg && <Image src={bgImages} loading="eager" layout="fill" className="fullImgs" alt={title} />}
                {isNewImg && <EFPic name={newImgList} className="fullImgs" loading="eager" alt={title} />}
                {isWebp && <NextImage webpSrc={webpSrc || bgImages} src={bgImages} alt={title} aria-label={title} />}
            </span>
            <div className="content">
                {titleShow && <h1 className="title font-family-semibolder">{title}</h1>}
                {singleShow && <h1 className="title single font-family-semibold">{singleTitle}</h1>}
                {subTitleShow && <p className="sub-title font-family-regular">{subTitle}</p>}
                <div className="search supportSearchField" style={{ display: isSearch ? 'block' : 'none' }}>
                    <Search
                        allowClear={true}
                        placeholder={t('support.site_support_search_title')}
                        value={value}
                        list={spuList}
                        autoFilter={true}
                        fieldNames={{ label: 'name', value: 'name' }}
                        onInputKeyDown={handleEnter}
                        onSelect={handleChange}
                        dorpDownDesc={dorpDownDesc}
                    />
                </div>
            </div>
        </div>
    );
}
